<template>
    <div :class="['container', 'pdf-preview-h5', { 'view_r': showViewR == 'views_r' }]">
        <div class="header">
            <img src="../../assets/img/h5/esc.png" alt="" @click="backHistory">
            <h3>{{title}}</h3>
            <span @click="toggleShow">全部资料({{data.materials.length}})</span>
        </div>
        <transition name="fade">
            <div class="pop-mask" v-if="showList" @click="toggleShow">
                <div class="list">
                    <p v-for="(item, index) in data.materials" :key="index" @click="clickPdf(item, index)" :class="{active: activeIndex == index}">{{item.title}}</p>
                </div>
            </div>
        </transition>
        <div class="null"></div>
       <iframe :src="pdf_src" frameborder="0" allowtransparency="true" class="pdf"></iframe>
    </div>
</template>
<script>
export default {
  name: 'Preview',
  data () {
    return {
        title: '',
        pdf_src: '',
        showList: true,
        activeIndex: 0,
        showViewR: false
    }
  },
  watch: {
    $route(){
        this.showViewR = this.$route.query.show
        let path = this.$route.query.path
        this.title = this.$route.query.title
        if (process.env.NODE_ENV === 'development') {
            this.pdf_src = `${window.location.origin}/pdf/web/viewer.html?file=/${path}`
        } else {
            this.pdf_src = `./pdf/web/viewer.html?file=../../${path}`
        }
    },
},
  mounted () {
    let path = this.$route.query.path
    this.title = this.$route.query.title
    this.showViewR = this.$route.query.show
    document.getElementsByClassName('container')[0].style.height = '100vh';
    if (process.env.NODE_ENV === 'development') {
        this.pdf_src = `${window.location.origin}/pdf/web/viewer.html?file=/${path}`
    } else {
        this.pdf_src = `./pdf/web/viewer.html?file=../../${path}`
    }
    if(this.data.materials) {
        this.data.materials.map((item, index) => {
            if(this.title == item.title) {
                this.activeIndex = index
            }
        })
    }
  },

  methods: {
     clickPdf(item, index) {
        this.activeIndex = index
        this.$router.replace({ name: this.$route.name, query: { ...this.$route.query, title: item.title, path: item.path } })
     },
     toggleShow() {
         this.showList = !this.showList
     },
     backHistory() {
         this.$router.replace({name: this.$route.query.redirect, query: { ...this.$route.query.query }})
     }
  },

  
}
</script>
<style lang="less" scoped>
    .container {
        position:relative;
        // padding-top: .6rem;
        width: 100%;
        height: 100vh;
        margin: 0 auto;
        .null{
            height: .8rem;
        }
        .header{
            height: .3rem;
            padding: .25rem 0;
            background: #f7f7f7;
            position: fixed;
            top: 0;
            display: flex;
            justify-content: space-between;
            width: 100%;
            line-height: 0.36rem;
            img{
                width: .19rem;
                height: .34rem;
                margin-left: .3rem;
            }
            h3{
                width: 10rem;
                text-align: center;
                font-size: .31rem;
                font-weight: normal;
                color: #252631;
                margin-left: .5rem;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                height: .5rem;
                line-height: .5rem;
                margin-top: -0.05rem;
            }
            span{
                font-size: .24rem;
                color: #252631;
                margin-top: -0.01rem;
                width: 3.2rem;
            }
        }
        .pdf {
            overflow: hidden;
            width: 100%;
            height: 100%;
        }
        .pop-mask{
            width: 100%;
            height: 110%;
            position: fixed;
            top: .8rem;
            z-index: 1;
            background: rgba(0, 0, 0, .6);
            .list{
                max-height: 8rem;
                overflow: auto;
                background: #fff;
                padding: .4rem .5rem;
                p{
                    font-size: .29rem;
                    color: #252631;
                    margin-bottom: .25rem;
                    letter-spacing: 0px;
                    &:last-of-type{
                        margin: 0;
                    }
                    &.active{
                        color: #005587;
                    }
                }
            }
        }
    }
    .view_r{
        .pop-mask, .pdf{
            width: 90%;
            left: 50%;
            transform: translateX(-50%);
            -webkit-transform: translateX(-50%);
            position: fixed;
            top: .9rem;
        }
        .pop-mask{
            width: 92%;
        }
    }
</style>
<style>
    .pdf-preview-h5 .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .pdf-preview-h5 .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
